import React from 'react'
import {AppLogoSvg} from 'appConfigs/svgs/AppLogoSvg'
import {IoEarth} from 'react-icons/io5'
import {TbBrandYoutubeFilled} from 'react-icons/tb'
import {BsFacebook, BsInstagram, BsLinkedin, BsTiktok, BsTwitterX} from 'react-icons/bs'
import {SiZalo} from 'react-icons/si'

// Icon cho 1 link trong linked_pages (LinkedPage polymorphic, xem app/Models/LinkedPage.php) -
// đoán icon từ URL thực tế (không phải từ label "page" do người dùng tự gõ, vì label có thể là bất
// kỳ chữ gì - vd "Nhóm Zalo lớp"). Tách ra dùng chung cho mọi nơi hiển thị linked_pages (Organization
// banner, trang lớp học...) thay vì mỗi nơi tự chép lại 1 bản logic đoán icon riêng.
export const LinkedPageIcon = ({url, size, className}) => {
    const u = (url || '').toLowerCase()

    if (u.includes('facebook.com')) return <BsFacebook size={size} className={className || 'text-blue-800'}/>
    if (u.includes('linkedin.com')) return <BsLinkedin size={size} className={className || 'text-blue-600'}/>
    if (u.includes('twitter.com') || u.includes('x.com')) return <BsTwitterX size={size} className={className || 'text-color-000'}/>
    if (u.includes('instagram.com')) return <BsInstagram size={size} className={className || 'text-orange-500'}/>
    if (u.includes('youtube.com')) return <TbBrandYoutubeFilled size={size} className={className || 'text-red-600'}/>
    if (u.includes('tiktok.com')) return <BsTiktok size={size} className={className || 'text-color-000'}/>
    if (u.includes('zalo.me')) return <SiZalo size={size} className={className || 'text-blue-500'}/>

    // URL nội bộ kristo.network → dùng logo app
    if (u.includes('kristo.network')) return <AppLogoSvg size={size}/>

    // fallback: globe icon thay vì link icon
    return <IoEarth size={size} className={className || 'text-gray-400'}/>
}

export default LinkedPageIcon
